function handleBuyButtonsOnScroll(scrollThreshold = 30) {
    const buyButtons = document.querySelectorAll('[data-block-type="buy-buttons"]');
    const footer = document.querySelector('.footer');

    let stickyHeight = 0;

    function updateStyles() {
        const scrolled = window.scrollY > scrollThreshold;
        // Footer in vista: anche la barra product-quick-add sparisce (ProductQuickAdd in theme.js)
        const footerReached = footer && footer.getBoundingClientRect().top < window.innerHeight;
        let height = 0;

        buyButtons.forEach(function (btn) {
            btn.style.bottom = scrolled ? '0' : '-100%';

            // La chat Klaviyo sale sopra il blocco quando si aggancia al fondo e resta sollevata fino al footer, anche
            // mentre il blocco scorre via e prima che compaia la barra product-quick-add: niente su e giu' (main-product.css)
            const rect = btn.getBoundingClientRect();
            const docked = rect.top < window.innerHeight && rect.bottom >= window.innerHeight - 2;
            if (getComputedStyle(btn).position === 'sticky' && (docked || (scrolled && !footerReached))) {
                height = Math.max(height, rect.height);
            }
        });

        // Scritta solo quando cambia: una variabile su :root ricalcola gli stili di tutta la pagina
        if (height !== stickyHeight) {
            stickyHeight = height;
            document.documentElement.style.setProperty('--buy-buttons-sticky-height', height + 'px');
        }
    }

    updateStyles();

    window.addEventListener('scroll', updateStyles);
    // bottom ha una transizione di 0.5s: a scroll fermo la posizione finale arriva solo qui
    buyButtons.forEach((btn) => btn.addEventListener('transitionend', updateStyles));
}

document.addEventListener('DOMContentLoaded', function () {
    handleBuyButtonsOnScroll(30);
});

// Widget di chat Zendesk disattivato dal cliente: l'app embed e' "disabled" in
// config/settings_data.json, quindi #launcher non viene piu' iniettato e questo blocco
// girerebbe a vuoto su ogni pagina. Disattivazione NON definitiva: per riattivarlo
// togliere /* e */ qui sotto e scommentare la regola #launcher in
// src/css/sections/product-info.css, poi rilanciare `npm run build:tailwind`.
/*
document.addEventListener('DOMContentLoaded', () => {
    // Nessun ancoraggio a una sezione (la FAQ e' stata rimossa una volta, puo'
    // succedere di nuovo): il launcher segue la profondita' di scroll della pagina.
    // ponytail: soglia unica per tutti i template, differenziarla solo se serve davvero
    const SHOW_AFTER = 0.5; // frazione di pagina scrollata oltre cui mostrare il launcher

    let shouldShowLauncher = false;

    function applyLauncherState() {
        const launcher = document.getElementById('launcher');
        if (!launcher) return;

        launcher.classList.toggle('visible', shouldShowLauncher);
    }

    function updateState() {
        const scrollable = document.documentElement.scrollHeight - window.innerHeight;

        // pagina che non scrolla: il contenuto e' gia' tutto sotto gli occhi
        shouldShowLauncher = scrollable <= 0 || window.scrollY / scrollable >= SHOW_AFTER;

        applyLauncherState();
    }

    window.addEventListener('scroll', updateState, {passive: true});
    window.addEventListener('resize', updateState);

    window.addEventListener('load', () => {
        updateState();
        setTimeout(updateState, 0);
    });

    updateState();

    // Gestione #launcher creato dopo
    const launcherObserver = new MutationObserver(() => {
        const launcher = document.getElementById('launcher');
        if (launcher) {
            applyLauncherState();
        }
    });

    launcherObserver.observe(document.documentElement, {
        childList: true,
        subtree: true
    });
});
*/

(() => {
    function adjustDividerPadding() {
        const dividers = document.querySelectorAll('.shopify-section.shopify-section--24-divider');

        dividers.forEach(divider => {
            const prevSection = divider.previousElementSibling?.querySelector('.section, .slideshow');
            const nextSection = divider.nextElementSibling?.querySelector('.section, .slideshow');
            const overrideEl = divider.querySelector('[data-override-padding]');

            if (!overrideEl || !prevSection || !nextSection) return;

            const override = overrideEl.dataset.overridePadding === 'true';

            if (override) {
                prevSection.style.paddingBottom = '0';
                nextSection.style.paddingTop = '0';
            } else {
                prevSection.style.paddingBottom = '';
                nextSection.style.paddingTop = '';
            }
        });
    }

    adjustDividerPadding();

    // Re-run when Shopify editor reloads sections
    document.addEventListener('shopify:section:load', adjustDividerPadding);
    document.addEventListener('shopify:section:reorder', adjustDividerPadding);
    document.addEventListener('shopify:block:select', adjustDividerPadding);
    document.addEventListener('shopify:block:deselect', adjustDividerPadding);
})();

// Toggle deselect for exclusive radio filters (color swatches)
document.addEventListener('click', (e) => {
    const label = e.target.closest('label[for]');
    if (!label) return;
    const input = document.getElementById(label.getAttribute('for'));
    if (!input || input.type !== 'radio' || !input.hasAttribute('data-allow-deselect')) return;
    if (input.checked) {
        e.preventDefault();
        input.checked = false;
        input.dispatchEvent(new Event('change', { bubbles: true }));
    }
});

// Lo slideshow di Impact avvia, quando seleziona una slide, solo la variante video visibile (mobile o desktop).
// Passando il breakpoint dei 700px, anche ruotando il telefono, la variante che compare restava ferma sulla cover
// e quella sparita continuava a girare nascosta: al cambio di breakpoint si rifa' la stessa scelta del tema.
// ponytail: la durata del ciclo dello slideshow in autoplay resta quella della variante iniziale
window.matchMedia('(min-width: 700px)').addEventListener('change', () => {
    document.querySelectorAll('slideshow-carousel').forEach((slideshow) => {
        const slide = slideshow.selectedSlide;
        if (slide?.getAttribute('data-slide-type') !== 'video') return;

        // Solo le varianti nascoste in pausa: con un video unico il play() seguente verrebbe ignorato, perche' il
        // pause() del tema e' asincrono e l'attributo playing c'e' ancora, e il video resterebbe fermo
        const videos = Array.from(slide.querySelectorAll('video-media'));
        const visibleVideo = videos.filter((video) => video.offsetParent !== null).pop();
        videos.forEach((video) => video !== visibleVideo && video.pause());
        visibleVideo?.play();
    });
});
